/**
 * Quotation Service API
 * This is the quotation-service API generated by springdocs - a library for OpenAPI 3 with spring boot.
 *
 * The version of the OpenAPI document: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RfqPropertyDto } from './rfqPropertyDto';


export interface RfqRequestDto { 
    id?: number;
    uid?: string;
    number?: string;
    status?: string;
    type?: string;
    profile?: string;
    dailyKwUsage?: number;
    day?: number;
    night?: number;
    dayKwUsage?: number;
    nightKwUsage?: number;
    dueDate?: Date;
    information?: string;
    fullName?: string;
    phone?: string;
    email?: string;
    contact?: string;
    householdSize?: string;
    importance?: string;
    coverage?: number;
    provinceId?: number;
    regionId?: number;
    property?: RfqPropertyDto;
}

